module.exports = __webpack_public_path__ + "static/media/48380610_2308773335864511_814816181507588096_o.94f4fba1.jpg";